import React, { useContext, useEffect, useState } from "react";
import { PageStep } from "./StepPage.types";
import { AppContext } from "../../../util/context";
import { sanitizeContent as s, replaceVariablesInText, getFieldsFormSession } from "../../../util/functions";
import NextButton from "../Buttons/NextButton";
import VideoElement from "../../VideoElement";
import SkipButton from "../Buttons/SkipButton";
import styles from "./StepPage.module.scss";
import block from 'bem-css-modules';

const StepPage = (props: { stepData: PageStep, activeStepIndex: number, stepIndex: number }) => {
  const context = useContext(AppContext);
  const { handleStepSubmit, settings: { submitButtonText, crm } } = context;
  const { product } = crm[0];

  const [doctorData, setDoctorData] = useState<any>(false);
  const [processedContent, setProcessedContent] = useState<string>("");

  const {
    activeStepIndex,
    stepIndex,
    stepData: {
      content,
      iframe,
      vimeoId,
      isSuccessPage,
      skipButton,
      doctorContactPage,
      doctorContactField,
      stepSettings: [{
        uuid,
        label,
        customNextButton,
        classes,
        nextStep,
        lastStep,
      }],
    },
  } = props;

  const b = block(styles);

  const handleClick = () => {
    const stepData = {
      label: label,
      uuid: uuid,
      settings: {
        tracking: {
          gtmEvent: `formClient.step.${label}`
        },
        classes,
        custom_next_button: customNextButton,
        next_step: nextStep,
        last_step: lastStep
      },
    }

    handleStepSubmit(context, stepData);
  }

  useEffect(()=> { 
    if (!content) return;
    setProcessedContent(replaceVariablesInText(content));
  }, [content]);

  useEffect(()=> { 
    if (!doctorContactPage) return;
    if (stepIndex === activeStepIndex) {
      const doctorField = getFieldsFormSession(doctorContactField);
      setDoctorData(doctorField);
    }
  }, [doctorContactPage, doctorContactField, activeStepIndex, stepIndex]);

  useEffect(()=> { 
    if (stepIndex === activeStepIndex) {
      setProcessedContent(replaceVariablesInText(content));
    }
  }, [activeStepIndex, stepIndex]);

  return (
    <div className={b()} >
      {content && <div className={`fc-page-content ${b("content")}`} dangerouslySetInnerHTML={{ __html: s(processedContent) }} />}
      {iframe?.map((el: any, i: number) => (
        <div key={i} className={b("iframe")}>
          <iframe src={el.iframeUrl} width="100%" height={el.iframeHeight} />
        </div>
      ))}

      {doctorData && (
        <div className={b("content")}>
          <p>
            <b>{doctorData.full_name}</b><br />
            {doctorData.address}<br />
            {doctorData.phone_number && (
              <>Telefon-Nr.: <a href={`tel:${doctorData.phone_number}`}>{doctorData.phone_number}</a><br /></>
            )}
            {doctorData.email && (
              <>E-Mail.: <a href={`mailto:${doctorData.email}`}>{doctorData.email}</a></>
            )}
          </p>
          <p className={b("doctornote")}>
            Hinweis: Sie können Ihrem Arzt gerne sagen, dass Sie gerne eine Kranus Lutera Verodnung hätten - es kann sein, dass Sie dadurch schneller einen Termin kriegen könnten.
          </p>
          {doctorData.phone && (
            <a className={b("callbutton")} href={`tel:${doctorData.phone}`}>Praxis jetz anrufen</a>
          )}
        </div>
      )}

      {!!vimeoId && <VideoElement vimeoId={vimeoId} />}

      <div className={b()}>
        <div className={b()}>
          {!isSuccessPage && <NextButton handleOnClick={handleClick} stepLabel={label} submitBtnText={customNextButton || submitButtonText} />}
        </div>
        { skipButton && 
            <SkipButton skipBtnText={skipButton} stepLabel={label} nextStep={nextStep}/>
          }
      </div>
    </div>
  )
}

export default StepPage;

